import { render } from "./StyledButton.vue?vue&type=template&id=6bfd32a6"
import script from "./StyledButton.vue?vue&type=script&lang=js"
export * from "./StyledButton.vue?vue&type=script&lang=js"

import "./StyledButton.vue?vue&type=style&index=0&id=6bfd32a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__